import { useState } from 'react';

import { useGetNecessaryData } from '../../../../shared/hooks/useGetNecessaryData';
import { foodsService } from '../../../services/foodsService';
import { recipesService } from '../../../services/recipesService';
import { getMeasurementOptions } from '../../../utils';
import { RecipeFormInitialData } from '../interfaces/RecipeFormInitialData';
import { RecipeFormValues } from '../interfaces/RecipeFormValues';
import { recipeToFormValues } from '../utils/recipeToFormValues/recipeToFormValues';

const getEmptyRecipeFormValues = (): RecipeFormValues => ({
  id: null,
  name: '',
  servingSize: 1,
  amount: '',
  servingMeasurement: '',
  description: '',
  image: null,
  ingredients: [],
});

/** null until the measurements and the recipe have loaded */
export const useRecipeFormInitialValues = (recipeId?: number) => {
  const [initialData, setInitialData] = useState<RecipeFormInitialData | null>(null);

  useGetNecessaryData(async () => {
    const [measurements, recipe] = await Promise.all([
      foodsService.getMeasurements(),
      recipeId ? recipesService.getRecipe(recipeId) : null,
    ]);

    const defaultValues = recipe
      ? recipeToFormValues(recipe)
      : getEmptyRecipeFormValues();

    const servingMeasurementOptions = getMeasurementOptions(
      measurements,
      recipe?.servingMeasurement,
    );

    setInitialData({
      recipe,
      defaultValues,
      servingMeasurementOptions,
    });
  }, [recipeId]);

  return initialData;
};
